import script from "./UserManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./UserManagement.vue?vue&type=script&setup=true&lang=js"

import "./UserManagement.vue?vue&type=style&index=0&id=39e77ffa&scoped=true&lang=css"

import exportComponent from "/Users/lidonglei/Documents/project/AIDean/dean_dhses_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39e77ffa"]])

export default __exports__